import { render, staticRenderFns } from "./_RestaurantCountHover.vue?vue&type=template&id=2ad61454"
import script from "./_RestaurantCountHover.vue?vue&type=script&lang=js"
export * from "./_RestaurantCountHover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports